import React from "react";
import { CoverageAreaProps } from "store/modules/Logistics/types.store";
import { DealerUsersProps } from "store/modules/DealerUsers/types.store";
import { ECoverageAreaType } from "enums/options/coverageArea";
import CardDriverAreaMap from "./components/CardDriverAreaMap";
import CardDriverAreaSingle from "./components/CardDriverAreaSingle";

interface CardDriverAreaProps {
  dealerSelected: string;
  currentCoverageArea: CoverageAreaProps;
  dealerDrivers: DealerUsersProps[];
}

const MAP_COVERAGE_AREA_TYPE = ECoverageAreaType.DealerMap;

function CardDriverArea({
  dealerSelected,
  currentCoverageArea,
  dealerDrivers,
}: CardDriverAreaProps) {
  if (currentCoverageArea.type === MAP_COVERAGE_AREA_TYPE) {
    return (
      <CardDriverAreaMap
        dealerSelected={dealerSelected}
        currentCoverageArea={currentCoverageArea}
        dealerDrivers={dealerDrivers}
      />
    );
  }

  return (
    <CardDriverAreaSingle
      dealerSelected={dealerSelected}
      currentCoverageArea={currentCoverageArea}
      dealerDrivers={dealerDrivers}
    />
  );
}

export default CardDriverArea;
